"use strict";

import getCurrentLp from "../util/getCurrentLp";

let groups = require("../regionalization/cards.json");

let url = document.location.href;
let isMeuVivo = url.indexOf("cliente-especial-meuvivo") > -1;
let isPortabilidade = url.search(/movimento=portabilidade/gi) > -1;
let isDoubleRedes = url.search(/doubleredes=true/gi) > -1;
let params = new URLSearchParams(window.location.search);
const paramsPlan = params.get("plano") && params.get("plano").toUpperCase();
const paramAction = params.get("acao");
const regional = params.get("regional") || "nacional";

let offer = false;

const skeleton = {
  "29M": {
    id: "card-29M",
    plan: 9,
    plan_sem_redes: 6,
    bonus: "3GB + 3GB na Fatura Digital",
    bonus_oferta: "6GB",
    price: "R$ 34,99/mês",
    price_filter: 29.99,
    price_sem_redes: "R$ 29,99/mês",
    permanencia: "",
    link: "https://lojaonline.vivo.com.br/checkout-express/selecao?site=vivo&plan=105008282",
    sku: "105008282",
    params: {},
    redes_sociais: [
      {
        title: "Instagram",
        icon: "./assets/img/icon-instagram.png",
      },
      {
        title: "Facebook",
        icon: "./assets/img/icon-facebook@1x.png",
      },
      {
        title: "Facebook Messenger",
        icon: "./assets/img/icon-messenger@1x.png",
      },
      {
        title: "X",
        icon: "./assets/img/icon-x@1x.png",
      },
      {
        title: "Pinterest",
        icon: "./assets/img/icon-pinterest@1x.png",
      },
      {
        title: "Tinder",
        icon: "./assets/img/icon-tinder@1x.png",
      },
      {
        title: "TikTok",
        icon: "./assets/img/logo-tiktok.svg",
      },
      {
        title: "Youtube",
        icon: "./assets/img/logo-youtube.png",
      },
    ],
    apps_ilimitados: [
      // {
      //   title: "WhatsApp",
      //   icon: "./assets/img/whats.png",
      // },
      {
        title: "Waze, ",
        icon: "./assets/img/waze.png",
      },
      {
        title: "Moovit",
        icon: "./assets/img/moovit.png",
      },
    ],
    apps_inclusos_title: "Apps inclusos no plano",
    apps_inclusos: "GoRead, Babbel e Skeelo Intermediário",
    ligacoes: "para qualquer operadora em todo o Brasil",
    regulamento: "",
    gbRedesSociais: "3GB",
    txtRedesSociais: "para suas redes sociais e vídeo por R$5,00",
    check: false,
    showCheck: true,
    flag: "",
    flagMeuVivo: "",
    desc_legal: {
      normal: "",
      redes: "",
    },
    streamingText:
      "Assine Vivo Controle e ganhe <br>30 dias de Amazon Prime <br>e Disney +",
  },
  "34M": {
    id: "card-34M",
    plan: 11,
    plan_sem_redes: 7,
    bonus: "4GB + 3GB na Fatura Digital",
    bonus_oferta: "7GB",
    price: "R$ 39,99/mês",
    price_filter: 34.99,
    price_sem_redes: "R$ 34,99/mês",
    permanencia: "",
    link: "https://lojaonline.vivo.com.br/checkout-express/selecao?site=vivo&plan=105008302",
    sku: "105008302",
    params: {},
    redes_sociais: [
      {
        title: "Instagram",
        icon: "./assets/img/icon-instagram.png",
      },
      {
        title: "Facebook",
        icon: "./assets/img/icon-facebook@1x.png",
      },
      {
        title: "Facebook Messenger",
        icon: "./assets/img/icon-messenger@1x.png",
      },
      {
        title: "X",
        icon: "./assets/img/icon-x@1x.png",
      },
      {
        title: "Pinterest",
        icon: "./assets/img/icon-pinterest@1x.png",
      },
      {
        title: "Tinder",
        icon: "./assets/img/icon-tinder@1x.png",
      },
      {
        title: "TikTok",
        icon: "./assets/img/logo-tiktok.svg",
      },
      {
        title: "Youtube",
        icon: "./assets/img/logo-youtube.png",
      },
    ],
    apps_ilimitados: [
      // {
      //   title: "WhatsApp",
      //   icon: "./assets/img/whats.png",
      // },
      {
        title: "Waze, ",
        icon: "./assets/img/waze.png",
      },
      {
        title: "Moovit",
        icon: "./assets/img/moovit.png",
      },
    ],
    apps_inclusos_title: "Apps inclusos no plano",
    apps_inclusos: "GoRead, Babbel, Skeelo Intermediário e Hube Jornais",
    ligacoes: "para qualquer operadora em todo o Brasil",
    regulamento: "",
    gbRedesSociais: "4GB",
    txtRedesSociais: "para suas redes sociais e vídeo por R$5,00",
    check: false,
    showCheck: true,
    flag: "",
    flagMeuVivo: "",
    desc_legal: {
      normal: "",
      redes: "",
    },
    textContent: "",
    streamingText:
      "Assine Vivo Controle e ganhe <br>30 dias de Amazon Prime <br>e Disney +",
  },
  "39M": {
    id: "card-39M",
    plan: 13,
    plan_sem_redes: 8,
    bonus: "5GB + 3GB na Fatura Digital",
    bonus_oferta: "8GB",
    price: "R$ 44,99/mês",
    price_filter: 39.99,
    price_sem_redes: "R$ 39,99/mês",
    permanencia: "",
    link: "https://lojaonline.vivo.com.br/checkout-express/selecao?site=vivo&plan=105008292",
    sku: "105008292",
    params: {},
    redes_sociais: [
      {
        title: "Instagram",
        icon: "./assets/img/icon-instagram.png",
      },
      {
        title: "Facebook",
        icon: "./assets/img/icon-facebook@1x.png",
      },
      {
        title: "Facebook Messenger",
        icon: "./assets/img/icon-messenger@1x.png",
      },
      {
        title: "X",
        icon: "./assets/img/icon-x@1x.png",
      },
      {
        title: "Pinterest",
        icon: "./assets/img/icon-pinterest@1x.png",
      },
      {
        title: "Tinder",
        icon: "./assets/img/icon-tinder@1x.png",
      },
      {
        title: "TikTok",
        icon: "./assets/img/logo-tiktok.svg",
      },
      {
        title: "Youtube",
        icon: "./assets/img/logo-youtube.png",
      },
    ],
    apps_ilimitados: [
      // {
      //   title: "WhatsApp",
      //   icon: "./assets/img/whats.png",
      // },
      {
        title: "Waze, ",
        icon: "./assets/img/waze.png",
      },
      {
        title: "Moovit",
        icon: "./assets/img/moovit.png",
      },
    ],
    apps_inclusos_title: "Apps inclusos no plano",
    apps_inclusos: "GoRead, Babbel, Skeelo Intermediário e Hube Jornais",
    ligacoes: "para qualquer operadora em todo o Brasil",
    regulamento: "",
    gbRedesSociais: "5GB",
    txtRedesSociais: "para suas redes sociais e vídeo por R$5,00",
    check: false,
    showCheck: true,
    flag: "",
    flagMeuVivo: "",
    desc_legal: {
      normal: "",
      redes: "",
    },
    streamingText:
      "Assine Vivo Controle e ganhe <br>90 dias de Amazon Prime <br>pagos pela Vivo*",
  },
  "39M-ACTION": {
    id: "card-39M-action",
    plan: 13,
    plan_sem_redes: 8,
    bonus: "5GB + 3GB na Fatura Digital",
    bonus_oferta: "8GB",
    subDetail: "",
    price: "R$ 44,99/mês",
    price_filter: 39.99,
    price_sem_redes: "R$ 39,99/mês",
    permanencia: "",
    link: "https://lojaonline.vivo.com.br/checkout-express/selecao?offer=",
    sku: "105008292",
    params: {},
    redes_sociais: [
      {
        title: "Instagram",
        icon: "./assets/img/icon-instagram.png",
      },
      {
        title: "Facebook",
        icon: "./assets/img/icon-facebook@1x.png",
      },
      {
        title: "Facebook Messenger",
        icon: "./assets/img/icon-messenger@1x.png",
      },
      {
        title: "X",
        icon: "./assets/img/icon-x@1x.png",
      },
      {
        title: "Pinterest",
        icon: "./assets/img/icon-pinterest@1x.png",
      },
      {
        title: "Tinder",
        icon: "./assets/img/icon-tinder@1x.png",
      },
      {
        title: "TikTok",
        icon: "./assets/img/logo-tiktok.svg",
      },
      {
        title: "Youtube",
        icon: "./assets/img/logo-youtube.png",
      },
    ],
    apps_ilimitados: [
      // {
      //   title: "WhatsApp",
      //   icon: "./assets/img/whats.png",
      // },
      {
        title: "Waze, ",
        icon: "./assets/img/waze.png",
      },
      {
        title: "Moovit",
        icon: "./assets/img/moovit.png",
      },
    ],
    apps_inclusos_title: "Apps inclusos no plano",
    apps_inclusos: "GoRead, Babbel, Skeelo Intermediário e Hube Jornais",
    ligacoes: "para qualquer operadora em todo o Brasil",
    regulamento: "",
    gbRedesSociais: "5GB",
    txtRedesSociais: "para suas redes sociais e vídeo por R$5,00",
    check: false,
    showCheck: true,
    flagMeuVivo: "",
    desc_legal: {
      normal: "",
      redes: "",
    },
    streamingText:
      "Assine Vivo Controle e ganhe <br>90 dias de Amazon Prime <br>pagos pela Vivo*",
  },
  "49M": {
    id: "card-49M",
    plan: 22,
    plan_sem_redes: 14,
    bonus: "8GB + 6GB de bônus*",
    bonusPurple: "Ganhe R$50,00 em Vale Bonus todos os meses",
    bonus_oferta: "15GB",
    price: "R$ 54,99/mês",
    price_filter: 54.99,
    price_sem_redes: "R$ 49,99/mês",
    link: "https://lojaonline.vivo.com.br/checkout-express/selecao?site=vivo&plan=44640499",
    // permanencia: "Permanência mínima de 12 meses",
    params: {},
    sku: "44640499",
    redes_sociais: [
      {
        title: "Instagram",
        icon: "./assets/img/icon-instagram.png",
      },
      {
        title: "Facebook",
        icon: "./assets/img/icon-facebook@1x.png",
      },
      {
        title: "Facebook Messenger",
        icon: "./assets/img/icon-messenger@1x.png",
      },
      {
        title: "X",
        icon: "./assets/img/icon-x@1x.png",
      },
      {
        title: "Pinterest",
        icon: "./assets/img/icon-pinterest@1x.png",
      },
      {
        title: "Tinder",
        icon: "./assets/img/icon-tinder@1x.png",
      },
      {
        title: "TikTok",
        icon: "./assets/img/logo-tiktok.svg",
      },
      {
        title: "Youtube",
        icon: "./assets/img/logo-youtube.png",
      },
    ],
    apps_ilimitados: [
      // {
      //   title: "WhatsApp",
      //   icon: "./assets/img/whats.png",
      // },
      {
        title: "Waze, ",
        icon: "./assets/img/waze.png",
      },
      {
        title: "Moovit",
        icon: "./assets/img/moovit.png",
      },
    ],
    apps_inclusos_title: "Apps inclusos no plano",
    apps_inclusos: "GoRead, Babbel, Skeelo Avançado e Hube Jornais",
    ligacoes: "para qualquer operadora em todo o Brasil",
    regulamento: "",
    gbRedesSociais: "8GB",
    txtRedesSociais: "para suas redes sociais e vídeo por R$5,00",
    check: false,
    showCheck: true,
    flag: "",
    flagMeuVivo: "",
    desc_legal: {
      normal: "",
      redes: "",
    },
    streamingText:
      "Assine Vivo Controle e ganhe <br>90 dias de Amazon Prime <br>pagos pela Vivo*",
    // textoLegalText: "TESTE",
  },
  "59M": {
    id: "card-59M",
    plan: 26,
    plan_sem_redes: 16,
    bonus: "10GB + 6GB de bônus*",
    bonusPurple: "Ganhe R$50,00 em Vale Bonus todos os meses",
    bonus_oferta: "10GB",
    link: "https://lojaonline.vivo.com.br/checkout-express/selecao?site=vivo&plan=44640509",
    price: "R$ 64,99/mês",
    price_filter: 59.99,
    price_sem_redes: "R$ 59,99/mês",
    params: {},
    permanencia: "",
    sku: "44640509",
    redes_sociais: [
      {
        title: "Instagram",
        icon: "./assets/img/icon-instagram.png",
      },
      {
        title: "Facebook",
        icon: "./assets/img/icon-facebook@1x.png",
      },
      {
        title: "Facebook Messenger",
        icon: "./assets/img/icon-messenger@1x.png",
      },
      {
        title: "X",
        icon: "./assets/img/icon-x@1x.png",
      },
      {
        title: "Pinterest",
        icon: "./assets/img/icon-pinterest@1x.png",
      },
      {
        title: "Tinder",
        icon: "./assets/img/icon-tinder@1x.png",
      },
      {
        title: "TikTok",
        icon: "./assets/img/logo-tiktok.svg",
      },
      {
        title: "Youtube",
        icon: "./assets/img/logo-youtube.png",
      },
    ],
    apps_ilimitados: [
      // {
      //   title: "WhatsApp",
      //   icon: "./assets/img/whats.png",
      // },
      {
        title: "Waze, ",
        icon: "./assets/img/waze.png",
      },
      {
        title: "Moovit",
        icon: "./assets/img/moovit.png",
      },
    ],
    apps_inclusos_title: "Apps inclusos no plano",
    apps_inclusos: "GoRead, Babbel, Skeelo Top e Hube Jornais",
    ligacoes: "para qualquer operadora em todo o Brasil",
    regulamento: "",
    gbRedesSociais: "10GB",
    txtRedesSociais: "para suas redes sociais e vídeo por R$5,00",
    check: false,
    showCheck: true,
    flag: "",
    flagMeuVivo: "",
    desc_legal: {
      normal: "",
      redes: "",
    },
    streamingText:
      "Assine Vivo Controle e ganhe <br>90 dias de Amazon Prime <br>pagos pela Vivo*",
  },
  // "69D": {
  //   id: "card-69D",
  //   plan: 23,
  //   plan_sem_redes: 13,
  //   bonus: "10GB + 3GB na Fatura Digital",
  //   bonus_oferta: "13GB",
  //   price: "R$ 74,99/mês",
  //   price_filter: 69.99,
  //   price_sem_redes: "R$ 69,99/mês",
  //   // permanencia: "",
  //   link: "https://lojaonline.vivo.com.br/checkout-express/selecao?site=vivo&plan=44640549",
  //   sku: "44640549",
  //   params: {},
  //   redes_sociais: [
  //     {
  //       title: "Instagram",
  //       icon: "./assets/img/icon-instagram.png",
  //     },
  //     {
  //       title: "Facebook",
  //       icon: "./assets/img/icon-facebook@1x.png",
  //     },
  //     {
  //       title: "Facebook Messenger",
  //       icon: "./assets/img/icon-messenger@1x.png",
  //     },
  //     {
  //       title: "X",
  //       icon: "./assets/img/icon-x@1x.png",
  //     },
  //     {
  //       title: "Pinterest",
  //       icon: "./assets/img/icon-pinterest@1x.png",
  //     },
  //     {
  //       title: "Tinder",
  //       icon: "./assets/img/icon-tinder@1x.png",
  //     },
  //     {
  //       title: "TikTok",
  //       icon: "./assets/img/logo-tiktok.svg",
  //     },
  //     {
  //       title: "Youtube",
  //       icon: "./assets/img/logo-youtube.png",
  //     },
  //   ],
  //   streaming: [
  //     {
  //       title: "Ganhe 1.000 Dotz na ativação e 500 todos os meses.",
  //       subtitle: "",
  //       link: "",
  //       icon: "./assets/img/logo-dotz.png",
  //       altIcon: "Logo Dotz",
  //     },
  //   ],
  //   apps_ilimitados: [
  //     {
  //       title: "WhatsApp",
  //       icon: "./assets/img/whats.png",
  //     },
  //     {
  //       title: "Waze, ",
  //       icon: "./assets/img/waze.png",
  //     },
  //     {
  //       title: "Moovit",
  //       icon: "./assets/img/moovit.png",
  //     },
  //   ],
  //   apps_inclusos_title: "Apps inclusos no plano",
  //   apps_inclusos: "GoRead, Babbel, Skeelo Top e Hube Jornais",
  //   ligacoes: "para qualquer operadora em todo o Brasil",
  //   regulamento: "",
  //   gbRedesSociais: "10GB",
  //   txtRedesSociais: "para suas redes sociais e vídeo por R$5,00",
  //   check: false,
  //   showCheck: true,
  //   flag: "Vivo Controle com Dotz",
  //   flagMeuVivo: "",
  //   desc_legal: {
  //     normal: "",
  //     redes: "",
  //   },
  //   streamingText:
  //     "Assine Vivo Controle e ganhe <br>90 dias de Amazon Prime <br>pagos pela Vivo*",
  // },
  "69T": {
    id: "card-69T",
    plan: 23,
    plan_sem_redes: 13,
    bonus: "10GB + 3GB na Fatura Digital",
    bonus_oferta: "13GB",
    price: "R$ 74,99/mês",
    price_filter: 69.99,
    price_sem_redes: "R$ 69,99/mês",
    // permanencia: "Permanência mínima de 12 meses",
    link: "https://lojaonline.vivo.com.br/checkout-express/selecao?site=vivo&plan=44640559",
    sku: "44640559",
    params: {},
    redes_sociais: [
      {
        title: "Instagram",
        icon: "./assets/img/icon-instagram.png",
      },
      {
        title: "Facebook",
        icon: "./assets/img/icon-facebook@1x.png",
      },
      {
        title: "Facebook Messenger",
        icon: "./assets/img/icon-messenger@1x.png",
      },
      {
        title: "X",
        icon: "./assets/img/icon-x@1x.png",
      },
      {
        title: "Pinterest",
        icon: "./assets/img/icon-pinterest@1x.png",
      },
      {
        title: "Tinder",
        icon: "./assets/img/icon-tinder@1x.png",
      },
      {
        title: "TikTok",
        icon: "./assets/img/logo-tiktok.svg",
      },
      {
        title: "Youtube",
        icon: "./assets/img/logo-youtube.png",
      },
    ],
    streaming: [
      {
        title: "Curta mais de 90 milhões de músicas e 450 mil vídeos",
        subtitle: "",
        link: "",
        icon: "./assets/img/logo-tidal.png",
        altIcon: "Logo Tidal",
      },
    ],
    apps_ilimitados: [
      // {
      //   title: "WhatsApp",
      //   icon: "./assets/img/whats.png",
      // },
      {
        title: "Waze, ",
        icon: "./assets/img/waze.png",
      },
      {
        title: "Moovit",
        icon: "./assets/img/moovit.png",
      },
    ],
    apps_inclusos_title: "Apps inclusos no plano",
    apps_inclusos: "GoRead, Babbel, Skeelo Top e Hube Jornais",
    ligacoes: "para qualquer operadora em todo o Brasil",
    regulamento: "",
    gbRedesSociais: "10GB",
    txtRedesSociais: "para suas redes sociais e vídeo por R$5,00",
    check: false,
    showCheck: true,
    flag: "Vivo Controle com TIDAL",
    flagMeuVivo: "",
    desc_legal: {
      normal: "",
      redes: "",
    },
    streamingText:
      "Assine Vivo Controle e ganhe <br>90 dias de Amazon Prime <br>pagos pela Vivo*",
  },
  "69N": {
    id: "card-69N",
    plan: 26,
    plan_sem_redes: 16,
    bonus: "10GB + 6GB de bônus*",
    bonusPurple: "Ganhe R$50,00 em Vale Bonus todos os meses",
    bonus_oferta: "13GB",
    price: "R$ 74,99/mês",
    price_filter: 69.99,
    price_sem_redes: "R$ 69,99/mês",
    // permanencia: "Permanência mínima de 12 meses",
    link: "https://lojaonline.vivo.com.br/checkout-express/selecao?site=vivo&plan=44640559",
    sku: "44640559",
    params: {},
    redes_sociais: [
      {
        title: "Instagram",
        icon: "./assets/img/icon-instagram.png",
      },
      {
        title: "Facebook",
        icon: "./assets/img/icon-facebook@1x.png",
      },
      {
        title: "Facebook Messenger",
        icon: "./assets/img/icon-messenger@1x.png",
      },
      {
        title: "X",
        icon: "./assets/img/icon-x@1x.png",
      },
      {
        title: "Pinterest",
        icon: "./assets/img/icon-pinterest@1x.png",
      },
      {
        title: "Tinder",
        icon: "./assets/img/icon-tinder@1x.png",
      },
      {
        title: "TikTok",
        icon: "./assets/img/logo-tiktok.svg",
      },
      {
        title: "Youtube",
        icon: "./assets/img/logo-youtube.png",
      },
    ],
    streaming: [
      {
        title: "Assinatura Netflix Padrão com anúncios inclusa",
        subtitle:
          "Assista a séries e filmes favoritos em até 2 aparelhos compatíveis por vez, em fill HD",
        link: "",
        icon: "./assets/img/icon-netflix.png",
        altIcon: "Logo Netflix",
      },
    ],
    apps_ilimitados: [
      // {
      //   title: "WhatsApp",
      //   icon: "./assets/img/whats.png",
      // },
      {
        title: "Waze, ",
        icon: "./assets/img/waze.png",
      },
      {
        title: "Moovit",
        icon: "./assets/img/moovit.png",
      },
    ],
    apps_inclusos_title: "Apps inclusos no plano",
    apps_inclusos: "GoRead, Babbel, Skeelo Top e Hube Jornais",
    ligacoes: "para qualquer operadora em todo o Brasil",
    regulamento: "",
    gbRedesSociais: "10GB",
    txtRedesSociais: "para suas redes sociais e vídeo por R$5,00",
    check: false,
    showCheck: true,
    flag: "",
    flagMeuVivo: "",
    desc_legal: {
      normal: "",
      redes: "",
    },
    streamingText:
      "Assine Vivo Controle e ganhe <br>90 dias de Amazon Prime <br>pagos pela Vivo*",
  },
  "79M": {
    id: "card-79M",
    plan: 27,
    plan_sem_redes: 15,
    bonus: "12GB + 3GB na Fatura Digital",
    bonus_oferta: "12GB",
    price: "R$ 84,99/mês",
    price_filter: 79.99,
    price_sem_redes: "R$ 79,99/mês",
    // permanencia: "Permanência mínima de 12 meses",
    link: "https://lojaonline.vivo.com.br/checkout-express/selecao?site=vivo&plan=44640529",
    sku: "44640529",
    params: {},
    redes_sociais: [
      {
        title: "Instagram",
        icon: "./assets/img/icon-instagram.png",
      },
      {
        title: "Facebook",
        icon: "./assets/img/icon-facebook@1x.png",
      },
      {
        title: "Facebook Messenger",
        icon: "./assets/img/icon-messenger@1x.png",
      },
      {
        title: "X",
        icon: "./assets/img/icon-x@1x.png",
      },
      {
        title: "Pinterest",
        icon: "./assets/img/icon-pinterest@1x.png",
      },
      {
        title: "Tinder",
        icon: "./assets/img/icon-tinder@1x.png",
      },
      {
        title: "TikTok",
        icon: "./assets/img/logo-tiktok.svg",
      },
      {
        title: "Youtube",
        icon: "./assets/img/logo-youtube.png",
      },
    ],
    apps_ilimitados: [
      // {
      //   title: "WhatsApp",
      //   icon: "./assets/img/whats.png",
      // },
      {
        title: "Waze, ",
        icon: "./assets/img/waze.png",
      },
      {
        title: "Moovit",
        icon: "./assets/img/moovit.png",
      },
    ],
    apps_inclusos_title: "Apps inclusos no plano",
    apps_inclusos:
      "GoRead, Babbel, NBA Básico, Vivo Meditação Lite, Skeelo Top, Super Comics e Hube Jornais",
    ligacoes: "para qualquer operadora em todo o Brasil",
    regulamento: "",
    gbRedesSociais: "12GB",
    txtRedesSociais: "para suas redes sociais e vídeo por R$5,00",
    check: false,
    showCheck: true,
    flag: "",
    flagMeuVivo: "",
    desc_legal: {
      normal: "",
      redes: "",
    },
    streamingText:
      "Assine Vivo Controle e ganhe <br>90 dias de Amazon Prime <br>pagos pela Vivo*",
  },
};

const mountCard = function (plans, normalParam = "", moreGB = 0) {
  let cards = plans.map(function (plan) {
    let card = skeleton[plan],
      gbCard = card.plan + moreGB,
      gbCardSemRedes = card.plan_sem_redes + moreGB,
      textCard;

    card.offer = offer;
    card.plan = `${gbCard}GB`;
    textCard = `${gbCardSemRedes}GB`;
    card.plan_sem_redes = textCard.replace(".", ",");

    if (groups[regional]) {
      groups[regional].map((group) => {
        const cardRegional = group[card.id];
        if (cardRegional) {
          if (cardRegional.price && card.price_sem_redes) {
            card.price_sem_redes = cardRegional.price;
            card.price = cardRegional.priceComRedes;
          }
          card.link = cardRegional.links[getCurrentLp()].default;
        }
      });
    }

    const actionGroup = groups[regional] && groups[regional][0][paramAction];

    if (actionGroup) {
      const currentCard = actionGroup[card.id];

      if (currentCard.price && currentCard.priceComRedes) {
        card.price_sem_redes = currentCard.price;
        card.price = currentCard.priceComRedes;
      }

      if (isDoubleRedes) {
        card.link = currentCard.links[getCurrentLp()].doubleRedes + idOrigin;
      } else {
        card.link = currentCard.links[getCurrentLp()].default + idOrigin;
      }
    }

    // if (isPortabilidade) {
    //   if (paramsPlan === "49M" || paramsPlan === "69N") {
    //     gbCard = gbCard + 5;
    //     gbCardSemRedes = gbCardSemRedes + 5;
    //     // card.flagMeuVivo = "";
    //     card.plan = `${gbCard}GB`;
    //     textCard = `${gbCardSemRedes}GB`;
    //     card.plan_sem_redes = textCard.replace(".", ",");
    //   }

    //   card.bonus_oferta += "<br/>+ 5GB bônus para Portabilidade*";
    //   card.bonus += "<br/>+ 5GB bônus para Portabilidade*";
    // }

    if (isPortabilidade) {
      document.querySelector(".cards--legal-text-portabilidade").style.display =
        "block";
    }

    if (!isDoubleRedes && isPortabilidade && card.id == "card-49M") {
      gbCard = gbCard + 5;
      gbCardSemRedes = gbCardSemRedes + 5;
      // card.flagMeuVivo = "";
      card.plan = `${gbCard}GB`;
      textCard = `${gbCardSemRedes}GB`;
      card.plan_sem_redes = textCard.replace(".", ",");
      card.bonus = "8GB + 6GB de bônus* <br /> +5GB bônus para Portabilidade**";
    }

    if (isPortabilidade && card.id == "card-49M" && isDoubleRedes) {
      gbCard = gbCard + 5;
      gbCardSemRedes = gbCardSemRedes + 5;
      // card.flagMeuVivo = "";
      card.plan = `${gbCard}GB`;
      textCard = `${gbCardSemRedes}GB`;
      card.plan_sem_redes = textCard.replace(".", ",");
      card.bonus = "8GB + 6GB de bônus* <br /> +5GB bônus para Portabilidade**";
    }

    if (!isDoubleRedes && isPortabilidade && card.id == "card-59M") {
      gbCard = gbCard + 5;
      gbCardSemRedes = gbCardSemRedes + 5;
      // card.flagMeuVivo = "";
      card.plan = `${gbCard}GB`;
      textCard = `${gbCardSemRedes}GB`;
      card.plan_sem_redes = textCard.replace(".", ",");
      card.bonus =
        "10GB + 6GB de bônus* <br /> +5GB bônus para Portabilidade** ";
    }

    if (isPortabilidade && card.id == "card-59M" && isDoubleRedes) {
      gbCard = gbCard + 5;
      gbCardSemRedes = gbCardSemRedes + 5;
      // card.flagMeuVivo = "";
      card.plan = `${gbCard}GB`;
      textCard = `${gbCardSemRedes}GB`;
      card.plan_sem_redes = textCard.replace(".", ",");
      card.bonus =
        "10GB + 6GB de bônus* <br /> +5GB bônus para Portabilidade** ";
    }

    if (isMeuVivo && card.id == "card-49M") {
      gbCard = gbCard + 2;
      gbCardSemRedes = gbCardSemRedes + 2;
      // card.flagMeuVivo = "";
      card.plan = `${gbCard}GB`;
      textCard = `${gbCardSemRedes}GB`;
      card.plan_sem_redes = textCard.replace(".", ",");

      card.bonus_oferta += "<br/>+ 2GB de bônus especial";
      card.bonus += "<br/>+ 2GB de bônus especial";
    }

    if (isMeuVivo && card.id == "card-59M") {
      gbCard = gbCard + 2;
      gbCardSemRedes = gbCardSemRedes + 2;
      // card.flagMeuVivo = "";
      card.plan = `${gbCard}GB`;
      textCard = `${gbCardSemRedes}GB`;
      card.plan_sem_redes = textCard.replace(".", ",");

      card.bonus_oferta += "<br/>+ 2GB de bônus especial";
      card.bonus += "<br/>+ 2GB de bônus especial";
    }

    card.bonus_oferta += moreGB ? ` + ${moreGB}GB de bônus por 12 meses**` : "";
    card.bonus += moreGB ? ` + ${moreGB}GB de bônus por 12 meses**` : "";

    if (
      !isMeuVivo &&
      card.id !== "card-69T" &&
      card.id !== "card-69N" &&
      card.id !== "card-39M-action"
    ) {
      card.flag = "SEM FIDELIDADE";
    }

    if (
      !isMeuVivo &&
      (card.id == "card-49M" || card.id == "card-59M" || card.id == "card-79M")
    ) {
      card.flag = "";
    }

    if (card.id !== "card-39M-action") card.flag = "";

    if (isMeuVivo) {
      card.flagMeuVivo = "oferta exclusiva";
    }

    if (isPortabilidade) {
      card.flag = "VEM PRA VIVO!";
    }

    // if (paramAction === "vivopay1" && plan !== "39M") {
    //   card.plan = `${gbCard + 10}GB`;
    //   card.plan_sem_redes = `${gbCardSemRedes + 10}GB`;
    //   card.bonus_oferta = `${gbCardSemRedes}GB + 10GB de bônus`;
    //   card.bonus = `${gbCardSemRedes}GB + 10GB de bônus`;
    //   card.subDetail = "ao pagar a 1ª fatura no Vivo Pay";
    //   card.flag = "Ganhe bônus com o Vivo Pay";
    // }

    // if (plan === "39M-ACTION" && paramAction === "vivopay3") {
    //   card.plan = `${gbCard + 8}GB`;
    //   card.plan_sem_redes = `${gbCardSemRedes + 8}GB`;
    //   card.bonus_oferta = `${
    //     gbCardSemRedes - moreGB
    //   }GB + 8GB de bônus <br/> + R$ 20 do seu dinheiro de volta`;
    //   card.bonus = `${gbCardSemRedes}GB + 8GB de bônus <br/> + R$ 20 do seu dinheiro de volta`;
    //   card.subDetail = "na primeira fatura paga com Vivo Pay";
    // }

    return card;
  });

  return cards;
};

export default {
  titulo_aba: "Conheça o Plano Controle da Vivo",
  getData: () => {
    let dataCards = {};
    let portabilidadeText =
      "*O bônus é elegível a clientes que trouxeram um número de outra operadora para a Vivo e tem validade de 12 meses.";
    let mvText =
      "*2GB Bônus mensal com validade de 12 (doze) meses, exclusivo para aquisição através do app Vivo.";

    // if (isPortabilidade) {
    //   document.querySelectorAll(".informacoes--itens.oferta-portabilidade")[0].textContent =
    //     portabilidadeText;
    // }

    // if (paramAction === "migradotz") {
    //   document.querySelectorAll(
    //     ".informacoes--itens.oferta-migradotz"
    //   )[0].textContent =
    //     "** Bônus Dotz são somente validos para os movimentos de Migração Pré Controle e para Novas Linhas/Portabilidade";
    // }

    // if (isMeuVivo) {
    //   document.querySelectorAll(
    //     ".informacoes--itens.oferta-meuvivo"
    //   )[0].textContent = mvText;
    // }

    switch (paramsPlan) {
      case "29M":
        dataCards = { mensal: ["29M"] };

        if (isPortabilidade) dataCards = { anual: ["49M"] };
        break;
      case "34M":
        dataCards = { mensal: ["34M", "39M"] };
        break;
      case "39M":
        dataCards = { mensal: ["39M"] };

        if (isMeuVivo || isPortabilidade) {
          dataCards = { mensal: ["39M", "49M"] };
        }

        break;
      case "49M":
        dataCards = { mensal: ["49M", "59M"] };

        break;
      case "59M":
        dataCards = { mensal: ["59M", "79M"] };

        if (isPortabilidade) dataCards = { mensal: ["59M"] };

        break;
      // case "69D":
      //   dataCards = { mensal: ["69D"] };

      //   if (paramAction === "migradotz") dataCards = { mensal: ["49M", "69D"] };
      //   break;
      case "69T":
        dataCards = { mensal: ["69T"] };
        break;
      case "69N":
        dataCards = { mensal: ["69N"] };
        break;
      case "79M":
        dataCards = { mensal: ["79M"] };
        break;
      default:
        dataCards = { mensal: ["49M", "59M"] };
        break;
    }

    if (!dataCards.mensal || !dataCards.anual)
      document.querySelector(".abas").style.display = "none";

    return {
      anual: dataCards.anual ? mountCard(dataCards.anual) : [],
      mensal: dataCards.mensal ? mountCard(dataCards.mensal) : [],
    };
  },

  getDataCard: (id) => {
    if (typeof id !== "string" || id.indexOf("card-") === -1) return false;
    const card = id.split("-")[1];
    return skeleton[card];
  },
};
